import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { Text } from '@cotera/client/app/components/ui/text';
import { Combobox } from '@cotera/client/v0/components/ui/combobox';
import type { ComboboxItem } from '@cotera/client/v0/components/ui/combobox';

export const AttachmentNodeView = ({
  node,
  updateAttributes,
  extension,
}: NodeViewProps) => {
  const value = (node.attrs['value'] as string) || '';
  // const isFreehand = (node.attrs['isFreehand'] as boolean) || false;
  const options = extension.options as {
    items?: ComboboxItem[];
  };

  const items = options.items || [];

  const handleChange = (selectedValue: string) => {
    // Check if the selected value exists in the provided items
    const isFromList = items.some((item) => item.value === selectedValue);

    updateAttributes({
      value: selectedValue,
      isFreehand: !isFromList,
    });
  };

  return (
    <NodeViewWrapper
      className="attachment-node react-renderer mt-4"
      data-drag-handle
    >
      <div
        className="p-2 border rounded-md bg-purple-100 select-none border-purple-300 flex flex-col gap-2"
        contentEditable={false}
        suppressContentEditableWarning
      >
        <Text.Label className="text-purple-500 font-medium">
          Attachment
        </Text.Label>
        <div className="flex flex-col w-full bg-background rounded-md">
          <Combobox
            items={items}
            value={value}
            onChange={handleChange}
            placeholder="Select or enter attachment..."
            searchPlaceholder="Search or type..."
            emptyMessage="No attachments found."
            allowCustomValues={true}
            className="w-full"
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
};
